<div class="blotter cash">
  <div class="header-blotter">
    <div
      *ngIf="showDownloadExcel"
      class="end-xs download-csv"
      (click)="generateExcel()"
      [ngClass]="pointerDisabled ? 'pointer-disabled' : ''"
    >
      Descargar excel
    </div>
  </div>
  <div class="table-blotter table-cash">
    <div class="scroll">
      <div class="table-grid-nvo">
        <ul class="header-grid">
          <li class="li-text-format" (click)="setSortingProp('operationDate')">
            Fecha
            <div class="sort-icon"></div>
          </li>
          <li class="li-text-format">Hora</li>
          <li class="li-number-format">Folio</li>
          <li class="li-text-format" (click)="setSortingProp('operationType')">
            Movimiento
            <div class="sort-icon"></div>
          </li>
          <li class="li-number-format" (click)="setSortingProp('amount')">
            Monto
            <div class="sort-icon"></div>
          </li>
          <li
            class="li-text-format"
            (click)="showTooltipR = true; viewTooltipH()"
            (clickOutside)="showTooltipH = false"
          >
            <div class="dashedB">Estatus</div>
            <hb-tooltip-component
              *ngIf="showTooltipH === true"
              [text]="helpHeader"
              [relativePosition]="'top'"
              [width]="200"
              [isLarge]="true"
            >
            </hb-tooltip-component>
          </li>
          <li class="li-text-format"></li>
        </ul>
        <div
          *ngIf="!showSkeleton && orders.length"
          class="body-grid"
          (clickOutside)="id = -1"
          (scroll)="onScroll($event)"
        >
          <ul class="row-grid" *ngFor="let c of orders; let i = index">
            <li class="li-text-format">{{ c.operationDate }}</li>
            <li class="li-text-format">{{ c.operationTime }}</li>
            <li class="li-number-format" data-recording-sensitive>
              {{ c.trackingKey }}
            </li>
            <li class="li-text-format">{{ c.operationConcept }}</li>
            <li
              class="li-number-format"
              [class.negative-cash]="c.statusColor === 'red'"
              [class.neutro-cash]="c.statusColor === 'gray'"
              [class.normal-cash]="c.statusColor === 'black'"
              data-recording-sensitive
            >
              {{ c.amount | hbCustomFormat: '$0,0.00' }}
            </li>
            <li
              *ngIf="c.showTooltip"
              class="li-text-format"
              [class.status]="c.showTooltip"
              [class.negative-cash]="c.statusColor === 'red'"
              [class.neutro-cash]="c.statusColor === 'gray'"
              [class.normal-cash]="c.statusColor === 'black'"
            >
              <div
                [class.dashedB-normal]="c.statusColor === 'black'"
                [class.dashedB-negative]="c.statusColor === 'red'"
                (clickOutside)="viewOnlyOneToolTip()"
                (click)="showTootltipRow(c, i); showTooltipR = true"
              >
                {{ c.operationStatusName }}
              </div>
              <hb-tooltip-component
                id="{{ i }}"
                *ngIf="id === i"
                [text]="infoSPEI"
                [relativePosition]="'left'"
                [width]="width"
                data-recording-sensitive
                [isLarge]="true"
              >
              </hb-tooltip-component>
            </li>
            <li
              *ngIf="!c.showTooltip"
              class="li-text-format"
              [class.status]="!c.showTooltip"
              [class.negative-cash]="c.statusColor === 'red'"
              [class.neutro-cash]="c.statusColor === 'gray'"
              [class.normal-cash]="c.statusColor === 'black'"
            >
              {{ c.operationStatusName }}
            </li>
            <li class="li-text-format">
              <span
                *ngIf="c.isCancelable"
                (click)="onShowModalCancelTransfer(c)"
                >Cancelar</span
              >
            </li>
          </ul>
        </div>
        <div class="none-rows" *ngIf="totalRows === 0">
          <i class="icon icon-atm-icn-ordenes"></i>
          <div>Aún no tienes órdenes</div>
        </div>
        <div
          *ngIf="showSkeleton"
          class="body-grid"
          (clickOutside)="id = -1"
          (scroll)="onScroll($event)"
        >
          <ul class="row-grid" *ngFor="let c of ordersEmptyState">
            <li class="li-text-format"><span class="skeleton"></span></li>
            <li class="li-text-format"><span class="skeleton"></span></li>
            <li class="li-number-format"><span class="skeleton"></span></li>
            <li class="li-text-format"><span class="skeleton"></span></li>
            <li class="li-number-format"><span class="skeleton"></span></li>
            <li class="li-text-format"><span class="skeleton"></span></li>
            <li class="li-text-format"><span class="skeleton"></span></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="order-number" *ngIf="totalRows > 0">
    <span>{{ orders.length }} / {{ orders.length }} registros</span>
  </div>

  <div class="legal-footer">
    Las devoluciones pueden demorar en reflejarse en tu contrato durante el día
    que se efectuaron.
  </div>
</div>
<app-full-modal
  *ngIf="showModalCancelTransfer"
  [action]="FULL_MODAL_ACTIONS.confirmation"
  subtitle="¿Deseas cancelar la transferencia?"
  [parentPosition]="parentPosition"
  (onConfirmationAction)="cancelTransfer(transferToCancel)"
  (onCloseModal)="closeCancelTransferModal()"
></app-full-modal>
